import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, CheckCircle2, ChevronRight } from "lucide-react";
import { Panel, TONES } from "./parts";

const Row = ({ item, muted }) => {
  const t = TONES[muted ? "grey" : item.tone];
  return (
    <li>
      <Link to={item.to} data-testid={`priority-${item.key}`}
        className={`flex min-h-[52px] items-center gap-3 rounded-lg border-l-2 ${t.bar} bg-white/[0.02] px-3 py-2 transition-colors duration-150 hover:bg-white/[0.06]`}>
        <span className={`h-2 w-2 shrink-0 rounded-full ${t.dot}`} />
        <span className="min-w-0 flex-1">
          <span className={`block text-sm ${muted ? "text-slate-400" : "text-white"}`}>{item.label(item.n)}</span>
          {item.hint && <span className={`block text-xs ${t.text}`}>{item.hint}</span>}
        </span>
        <ChevronRight className="h-4 w-4 shrink-0 text-slate-500" />
      </Link>
    </li>
  );
};

export const PriorityZone = ({ urgent, rest, loaded }) => {
  const [all, setAll] = useState(false);
  return (
    <Panel title="À traiter" icon={AlertCircle} testid="zone-priorities"
      action={urgent.length > 0 && <span className="rounded-full bg-red-500/15 px-2.5 py-0.5 text-xs font-medium text-red-200" data-testid="priorities-count">{urgent.length}</span>}>
      {loaded && !urgent.length && (
        <p className="flex items-center gap-2 rounded-lg bg-emerald-500/[0.07] px-3 py-3 text-sm text-emerald-200" data-testid="priorities-empty">
          <CheckCircle2 className="h-4 w-4" />Rien d'urgent : tout est à jour.
        </p>
      )}
      <ul className="space-y-1.5">{urgent.map((i) => <Row key={i.key} item={i} />)}</ul>
      {all && <ul className="mt-1.5 space-y-1.5" data-testid="priorities-rest">{rest.map((i) => <Row key={i.key} item={i} muted />)}</ul>}
      {rest.length > 0 && (
        <button onClick={() => setAll((v) => !v)} className="mt-3 text-sm text-cyan-300 hover:text-cyan-200" data-testid="priorities-toggle-all">
          {all ? "Masquer les autres actions" : "Voir toutes les actions"}
        </button>
      )}
    </Panel>
  );
};
